import React from 'react';
import { css } from 'emotion';
import { Button } from '../../../../shared/Button/NewButton';
import {
  Section,
  ContentWrapper,
  Heading,
  SubHeader,
  HeroImageContainer,
  HeroImageMobileWrapper,
  HeroImageDesktopWrapper,
  HeroImageDesktopPictureWrapper1,
  HeroImageDesktopPictureWrapper2,
} from './styles';
import { RetinaPicture } from '../../../../components/RetinaPicture';

export function Hero() {
  return (
    <Section>
      <ContentWrapper>
        <Heading>The easiest way to grow your audience with audio.</Heading>
        <Button
          color="onDark"
          className={css`
            width: 240px;
            margin: 48px 0 20px;
          `}
          kind="link"
          href="/signup?ref=wp"
        >
          Get started
        </Button>
        <SubHeader>
          If you’re already on Anchor, you’ll need to create a new account.
        </SubHeader>
        <HeroImage />
      </ContentWrapper>
    </Section>
  );
}

function HeroImage() {
  return (
    <HeroImageContainer>
      <HeroImageMobileWrapper>
        <RetinaPicture
          imagePath="/wordpress/hero-mobile"
          alt="Smiling woman wearing headphones writing in a notebook"
          fallbackExtension="jpg"
        />
      </HeroImageMobileWrapper>
      <HeroImageDesktopWrapper>
        <HeroImageDesktopPictureWrapper1>
          <RetinaPicture
            imagePath="/wordpress/hero"
            alt="Smiling woman wearing headphones writing in a notebook"
            fallbackExtension="jpg"
          />
        </HeroImageDesktopPictureWrapper1>
        <HeroImageDesktopPictureWrapper2>
          <RetinaPicture
            imagePath="/wordpress/convert-post-ui"
            alt="Abstract user interface to convert an WordPress blog post into a podcast"
            fallbackExtension="png"
          />
        </HeroImageDesktopPictureWrapper2>
      </HeroImageDesktopWrapper>
    </HeroImageContainer>
  );
}
